export default __webpack_public_path__ + "static/media/moniquenicassio.9eb99f55.jpg";